import { useRef } from 'react';
import {EqualityComparer} from "@wix/devzai-utils-common";

export function useEqualityCheckedMemo<T>(value: T, equalityComparer: EqualityComparer<T>): T {
  const memoizedRef = useRef<T>(value);
  
  if (memoizedRef.current !== value && !equalityComparer(memoizedRef.current, value)) {
    memoizedRef.current = value;
  }
  
  return memoizedRef.current;
}